import axios from 'axios';

export const codeGenerator = {
  data() {
    return {
      inculdeArray: [
        '#include <FR_Infrared.h>',
        '#include <FR_UltraSonic.h>',
        '#include <FR_LightSensor.h>',
        '#include <FR_MicroSwitch.h>',
        '#include <FR_SoilMoisture.h>',
        '#include <FR_Hall.h>',
        '#include <FR_DCMotor_TB.h>',
        '#include <FR_ServoMotor.h>',
        '#include <FR_RGB_LED.h>',
        '#include <FR_Buzzer.h>',
        '#include <FR_ServoExtension310.h>',
        '#include <FR_LEDRing.h>',
      ],
      declareArray: [
        'FR_Infrared IR_port_01(A0,A1);',
        'FR_Infrared IR_port_02(A2,A3);',
        'FR_UltraSonic US_port_03(A7);',
        'FR_LightSensor LS_port_01(A0);',
        'FR_LightSensor LS_port_02(A2);',
        'FR_MicroSwitch MS_port_01(A0);',
        'FR_MicroSwitch MS_port_02(A2);',
        'FR_SoilMoisture SM_port_01(A0);',
        'FR_SoilMoisture SM_port_02(A2);',
        'FR_Hall HALL_port_01(A0);',
        'FR_Hall HALL_port_02(A2);',
        'int len;',
        'byte buff[30];',

        'FR_DCMotor_TB DC_motor_port_m1(8,6,0);',
        'FR_DCMotor_TB DC_motor_port_m2(4,5,1);',
        'FR_ServoMotor s1;',
        'FR_ServoMotor s2;',
        'FR_RGB_LED rgbleds(2,2);',
        'FR_Buzzer buz(3);',
        'FR_ServoExtension310 se;',
      ],
      setupArray: [
        'Serial.begin(57600);',
        'Serial.setTimeout(50);',
        's1.attach(10);',
        's2.attach(9);',
      ],
      switchArray: [
        'case 0: Serial.write(codeID); break;',
        "case 1: Serial.write(IR_port_01.getValue('L')); break;",
        "case 2: Serial.write(IR_port_01.getValue('R')); break;",
        "case 3: Serial.write(IR_port_02.getValue('L')); break;",
        "case 4: Serial.write(IR_port_02.getValue('R')); break;",
        'case 5: Serial.print(US_port_03.getValue()); break;',
        'case 6: Serial.write(LS_port_01.getValue()); break;',
        'case 7: Serial.write(LS_port_02.getValue()); break;',
        'case 8: Serial.write(MS_port_01.getValue()); break;',
        'case 9: Serial.write(MS_port_02.getValue()); break;',
        'case 10: Serial.write(SM_port_01.getValue()); break;',
        'case 11: Serial.write(SM_port_02.getValue()); break;',
        'case 12: Serial.write(HALL_port_01.getValue()); break;',
        'case 13: Serial.write(HALL_port_02.getValue()); break;',
      ],
      switchfuncArray: [],
      functionArray: [],
      variableArray: [],
      initLoopHeader:
        `\nvoid loop(){
          while(!Serial.available()){}
          if(Serial.read() == 0xFF){
            len = Serial.readBytesUntil(0xFE, buff, 30);
            switch(buff[0]){`,
      initLoopFooter: 'default: break;}}}\n',
      code: '',
      codeID: 'PJMADE',
      // eslint-disable-next-line no-use-before-define
      hexData: defaultHex,
    };
  },
  methods: {
    compileByCompileServer(board, thecode) {
      console.log(board, thecode);
      const promise = new Promise((resolve, reject) => {
        axios
          .post('https://compiler.fliprobot.com/E_Series', {
            code: thecode,
            board,
          })
          .then((response) => {
            resolve({ hexData: response.data, hexPath: null });
          })
          .catch((error) => {
            // eslint-disable-next-line prefer-promise-reject-errors
            console.log(error);
            resolve({ hexData: '', hexPath: null });
            // reject('Complie error', error);
          });
        setTimeout(() => {
          reject(new Error('WHatever'));
        }, 10000);
      });
      return promise;
    },
    createCode() {
      const code = `${this.inculdeArray.join('\n')}
        \n${this.declareArray.join('')}
        \n${this.variableArray.join('')}\n`
        + `char codeID[] = "${this.codeID}";`
        + `\nvoid setup() {${this.setupArray.join('')}}${this.initLoopHeader}${this.switchArray.join(
          '',
        )}${this.switchfuncArray.join('')}${this.initLoopFooter}${this.functionArray.join('')}`;

      console.log(code);

      return this.compileByCompileServer('E310', code)
        .then((result) => {
          this.hexData = result.hexData;
          return { sucess: true, hex: result.hexData };
        })
        .catch((err) => {
          // eslint-disable-next-line no-use-before-define
          this.hexData = defaultHex;
          return { sucess: false, hex: '', err };
        });
    },
    addFunc(funcs, vars, imports) {
      this.hexData = '';
      if (imports.length) {
        this.declareArray = [...this.declareArray, ...imports];
      }
      this.functionArray = funcs;
      this.variableArray = vars || [];
      this.switchfuncArray = [];
      const returnFuncArray = [];
      funcs.forEach((el, i) => {
        const thisFuncName = el
          .match(/void\s.*\(/g)[0]
          .split(' ')[1]
          .slice(0, -1);
        if (thisFuncName !== 'transArray') {
          this.switchfuncArray.push(
            `case ${14 + i}: ${thisFuncName}();Serial.write(1); break;`,
          );
          returnFuncArray.push({
            name: thisFuncName,
            code: 14 + i,
          });
        }
      });
      this.codeID = Math.random()
        .toString(36)
        .substring(2, 8);

      return returnFuncArray;
    },
    transSpeed(time, pre, cur) {
      return Math.floor(255 * (300 / (time * 1000 * 0.8)) * (Math.abs(pre - cur) / 180));
    },

    rasParse(name, data) {
      // console.log(data)
      const replaceData = data
        .replace(/rotation_clockwise/g, 'f')
        .replace(/rotation_counterclockwise/g, 'r')
        .replace(/OPTIONNAME/g, 's');

      console.log('@@@@@@');
      // console.log(replaceData);

      const timeData = JSON.parse(replaceData);
      const actionArray = [];
      for (let i = 0; i < timeData.length; i += 1) {
        let tmpStr = '';
        const motorsData = timeData[i].state;
        const servoAnglesNum = [90, 90, 90, 90, 90, 90, 90, 90];
        let hasServoExtension = false;
        let dcStopStr = '';

        if (timeData[i].blockType === 1) {
          tmpStr += 'lastTime = millis();';
          for (let j = 0; j < motorsData.length; j += 1) {
            // console.log(motorsData[j]);
            if (motorsData[j].data === 13 || motorsData[j].data === 14) {
              tmpStr += `DC_motor_port_m${motorsData[j].data - 12}.rotate('${
                motorsData[j].rotation
              }', ${motorsData[j].speed});`;
              dcStopStr += `DC_motor_port_m${motorsData[j].data - 12}.rotate('s',0);`;
            } else if (motorsData[j].data === 9 || motorsData[j].data === 10) {
              let preAngle = 90;
              if (i !== 0) preAngle = timeData[i - 1].state[j].angle;
              const speed = this.transSpeed(timeData[i].time, preAngle, motorsData[j].angle);
              tmpStr += `s${motorsData[j].data - 8}.write(${motorsData[j].angle},${speed});`;
            } else {
              hasServoExtension = true;
              servoAnglesNum[motorsData[j].data - 1] = motorsData[j].angle;
            }
          }
          if (hasServoExtension) {
            const angleArrayStr = servoAnglesNum.join(',');
            tmpStr += `transArray(${angleArrayStr},toSendAngle);
             se.rotate(toSendAngle,${timeData[i].time * 1000});
            `;
          }
          tmpStr += `while(millis()-lastTime < ${timeData[i].time * 1000 + 20});`;
          if (dcStopStr !== '') tmpStr += dcStopStr;
        } else if (timeData[i].blockType === 2) {
          // functionStr += "    delay(" + String(timeData[i].time * 1000+20) + ");\n";
          tmpStr += 'lastTime = millis();';
          tmpStr += `while(millis()-lastTime <${timeData[i].time * 1000 + 20});`;
        }
        actionArray.push(tmpStr);
      }

      const functionStr = `void ${name}(){
      byte toSendAngle[8];
      long lastTime=0;
      ${actionArray.join('\n')}
      }`;
      return functionStr;
    },
    getCodeID() {
      return this.codeID;
    },
  },
};

export default codeGenerator;

// eslint-disable-next-line no-multi-str
const defaultHex = `:100000000C9495000C94BD000C94BD000C94BD00A4
:100010000C94BD000C94BD000C94BD000C948F108A
:100020000C94BD000C94BD000C94BD000C946F03A7
:100030000C94BD000C94BD000C94BD000C94BD004C
:100040000C94AF090C94BD000C943A0D0C946C0DFB
:100050000C94BD000C94BD000C94BD000C94BD002C
:100060000C94BD000C94BD000C94BD000C94BD001C
:100070000C94C90D0C94FB0D0C94BD000C94BD00A8
:100080000C94BD000C94BD000C94BD000C94BD00FC
:100090000C94BD000C94BD000C94BD000C94BD00EC
:1000A0000C94BD000C94BD000C94BD000C94BD00DC
:1000B0000C94BD00090C0D080002010000030407A8
:1000C0000000000000000000000000000102040821
:1000D00010204080010204081020010204081020B2
:1000E00004080102040404040404040402020202D9
:1000F00002020303030303030505050500000000D6
:100100002300260029002C00000000002500280004
:100110002B002E0000000000240027002A002D00E4
:10012000020066019C0D2B0EC50111241FBECFEFEE
:10013000D8E0DEBFCDBF11E0A0E0B1E0E8E5F9E234
:1001400002C005900D92A233B107D9F723E0A2E3D4
:10015000B1E001C01D92A732B207E1F710E0C4E997
:10016000D0E004C02197FE010E946D13C139D10770
:10017000C9F70E94EC100C949F140C940000CF92CD
:10018000DF92EF92FF920F931F93E82FF92F05C094
:10019000015011092109310961F1908196239417C9
:1001A000B9F305C0015011092109310911F19081FC
:1001B00096239413F7CFC12CD12CE12CF12C0AC03B
:1001C0008FEFC81AD80AE80AF80A0C151D052E0583
:1001D0003F0579F080818623841791F36C2D7D2D66
:1001E0008E2D9F2D1F910F91FF90EF90DF90CF905C
:1001F000089560E070E080E090E01F910F91FF9023
:10020000EF90DF90CF900895DC01ED91FC9101908B
:10021000F081E02D099426E040E051EE60E070E0CE
:1002200082EE91E00E94DE0C42E350E060E070E07C
:1002300082EE91E00E940E106AE070E086E591E0A7
:100240000E94470569E070E080E591E00C94470565
:100250000F9300E02FEF40E061E070E08BE391E06E
:100260000E94310968EE73E080E090E00E942A0A63
:1002700020E040E061E070E08BE391E00E94310912
:1002800068EE73E080E090E00F910C942A0A0F93DF
:1002900000E020E04FEF61E070E08BE391E00E942E
:1002A000310968EE73E080E090E00E942A0A20E0C5
:1002B00040E061E070E08BE391E00E94310968EE7C
:1002C00073E080E090E00F910C942A0A4FE06EE01A
:1002D0008DE891E00E94630241E160E18BE891E0EA
:1002E0000E94630265E18AE891E00E9479026EE073
:1002F00089E891E00E94D70260E188E891E00E94DD
:10030000D7026EE087E891E00E94EB0260E186E8A8
:1003100091E00E94EB026EE085E891E00E94F80215
:1003200060E184E891E00E94F8026EE083E891E0E9
:100330000E944C0360E182E891E00E944C0320E0BF
:1003400046E068E08FE591E00E94690321E045E026
:1003500064E08CE591E00E94690386E591E00E94EB
:10036000AC0480E591E00E94AC0442E062E070E001
:100370008BE391E00E94BB0763E08AE391E00E9477
:10038000940982E391E00C9497098BE391E00C943B
:100390004D0582EE91E00E94F70B892BD1F382EE9E
:1003A00091E00E94110C8F3F910509F07EC02EE173
:1003B00030E042E651E06EEF82EE91E00E941410D0
:1003C0009093810180938001E0916201EF70E15090
:1003D000EF30A0F4F0E0E151FE4F0C946D130D02EC
:1003E00018021A021E0220022C02320235023A02C0
:1003F0003D02420245024A024D02520246E051E0ED
:10040000FA0101900020E9F7AF014750514066E042
:1004100071E082EE91E00C94580E6CE48DE891E06E
:100420000E946802682F70E082EE91E00C94040153
:1004300062E5F4CF6CE48BE891E0F2CF62E5FBCFAC
:100440008AE891E00E947C02AB01BC0122E030E02E
:1004500082EE91E00C94DE0F89E891E00E94DB02CD
:10046000BC01E2CF88E891E0F9CF87E891E00E94F3
:10047000EF02F6CF86E891E0FACF85E891E00E949E
:10048000FC02EECF84E891E0FACF83E891E00E948D
:100490005003E6CF82E891E0FACF0E94280161E0A4
:1004A00070E0C2CF0E944701FACF0895CF93DF9347
:1004B000EC0160E088810E94220B60E08981DF917D
:1004C000CF910C94220BFC01408361830C94560263
:1004D0006C3451F4FC0180810E94C10A21E0892B17
:1004E00009F420E0822F08956235E1F7FC01818153
:1004F000F3CFFC0160830895CF92DF92EF92FF92D9
:10050000CF93DF93EC0161E088810E94220B60E0D1
:1005100088810E945E0B82E090E00E94630A61E0A5
:1005200088810E945E0B8AE090E00E94630A60E08E
:1005300088810E945E0B60E088810E94220B20EA85
:1005400036E841E050E061E088810E94B50B2AE383
:1005500030E040E050E00E944B13CA01B9010E9414
:1005600016126B017C0169E170E080E090E00E946E
:100570002A0A20E030E040E85FE3C701B6010E94AC
:10058000691187FF06C0C12CD12C88ECE82E83E4CA
:10059000F82EC701B601DF91CF91FF90EF90DF9069
:1005A000CF90089560E0FC0180810C94220BFC0147
:1005B00060830C94D202FC0180810E94C10A2FEF5B
:1005C00033E0A901481B590BCA01089560E0FC0102
:1005D00080810C94220BFC0160830C94E602FC01E8
:1005E00080810C948C0B60E0FC0180810C94220BC8
:1005F000FC0160830C94F302CF93DF93EC018881BC
:100600000E94C10ABC01990F880B990B0E94181215
:1006100020E030E040EB50E40E946E1120E030E03A
:10062000A9010E94691187FD2CC088810E94C10A1E
:10063000BC01990F880B990B0E94181220E030E042
:1006400040EB50E40E946E1120E030E048EC52E4B0
:100650000E94C8121816C4F088810E94C10ABC0109
:10066000990F880B990B0E94181220E030E040EBA4
:1006700050E40E946E110E94E011CB01DF91CF91F6
:10068000089590E080E0FACF84E690E0F7CF60E054
:10069000FC0180810C94220BFC0160830C944703C5
:1006A000FC0180810E948C0B21E030E0892B11F04D
:1006B00030E020E0C9010895CF93DF93EC0161E0C1
:1006C00088810E94220B61E08981DF91CF910C9497
:1006D000220BFC016083418322830C945C031F92F4
:1006E0000F920FB60F9211242F933F934F935F9366
:1006F0006F937F938F939F93AF93BF93EF93FF93EA
:100700008091900187FF26C010928500109284008E
:10071000809190018F5F8093900180919001082ECD
:10072000000C990B20918F012817190629F024F04D
:10073000809190018C308CF18091840090918500A3
:1007400084329E4408F4FEC080918400909185001C
:100750000496FAC080919001082E000C990B20910C
:100760008F0128171906A1F29CF23091900126E022
:100770003203F0011124EF56FE4F808186FFC8CF6F
:10078000309190013203F0011124EF56FE4F808129
:1007900060E08F730E945E0BBBCF3091900126E02A
:1007A0003203F0011124EF56FE4F8581882309F4AE
:1007B0008EC040919001309190014203D0011124EC
:1007C000AF56BE4F3203F0011124EF56FE4F139681
:1007D0004D915C91818192818417950708F04AC000
:1007E00040919001309190013203F0011124EF56B5
:1007F000FE4F4203D0011124AF56BE4F15968C9187
:1008000041815281840F952F911D92838183409164
:100810009001309190014203D0011124AF56BE4F98
:100820003203F0011124EF56FE4F13964D915C9167
:10083000818192818417950708F449C04091900105
:10084000309190013203F0011124EF56FE4F420324
:10085000D0011124AF56BE4F13968D919C91928377
:100860008183309190013203F0011124EF56FE4F45
:1008700015822DC040919001309190013203F0011A
:100880001124EF56FE4F4203D0011124AF56BE4F44
:1008900015963C9181819281831B9109928381837A
:1008A00040919001309190014203D0011124AF5644
:1008B000BE4F3203F0011124EF56FE4F13964D91B7
:1008C0005C91818192814817590708F0B7CF8091D8
:1008D0008400909185003091900126E03203F00170
:1008E0001124EF56FE4F41815281840F951F909342
:1008F000890080938800309190013203F001112427
:10090000EF56FE4F808186FF0CC03091900132037C
:10091000F0011124EF56FE4F808161E08F730E9439
:100920005E0BFF91EF91BF91AF919F918F917F915E
:100930006F915F914F913F912F910F900FBE0F904C
:100940001F90189580E29EE4909389008093880020
:100950008FEF80939001E5CFDC01E0918F01EC30C7
:10096000C8F481E08E0F80938F01EC9386E0E89FBE
:10097000F0011124EF56FE4F8CED95E092838183B8
:1009800015961C9215978DE091E014969C938E938A
:10099000139708958FEF8C930895DF92EF92FF9253
:1009A0000F931F93CF93DF93EC01D62E7A01890129
:1009B00088818C3008F062C061E08D2D0E94220B8E
:1009C000888196E0899FF0011124EF56FE4F9D2DFE
:1009D0009F736081607C692B608324EF31E02E1966
:1009E0003F0937FF02C02D5F3F4F3595279535955D
:1009F0002795298324EC39E0201B310B37FF02C0F7
:100A00002D5F3F4F35952795359527952A832CE007
:100A1000622F0E943F13829FB001112430E020E03A
:100A200096E0AB01420F531F949FF001959FF00D8C
:100A30001124EF56FE4F408146FD16C02F5F3F4FF9
:100A40002C30310571F781110FC01092800082E0C7
:100A5000809381001092850010928400B19A809159
:100A60006F00826080936F00E88186E0E89FF0016C
:100A70001124EF56FE4F8081806480838881DF914E
:100A8000CF911F910F91FF90EF90DF90089524EC8C
:100A900039E044EF51E00C94CD04CF93DF93EC01A7
:100AA00088859985009711F00E940F148E8187FD2B
:100AB00005C060E0DF91CF910C94220BDF91CF91C4
:100AC0000895CF93DF93EC018E8187FD07C061E02D
:100AD0000E94220B60E08E810E945E0B81E0898380
:100AE000DF91CF910895EF92FF920F931F93CF93D1
:100AF000DF93EC017B0188859985009711F00E94B6
:100B00000F149D858A85981701F184E090E08E9DF1
:100B100080018F9D100D9E9D100D11241D830C834F
:100B2000C8010E94731399878887009789F0A801EC
:100B300070E060E00E949814FB82EA82DF91CF911E
:100B40001F910F91FF90EF90089583E090E0DFCF29
:100B50001D821C821B821A82F1CFFC01B585A28501
:100B60009B0186E0369527958A95E1F723702587C6
:100B7000CB0134E0969587953A95E1F783708287AB
:100B8000AB01569547955695479543704387962FE9
:100B90009370948791E06F3F710511F008F090E039
:100BA000908340855185452B69F031E0BA1330E0E0
:100BB00091E0281390E0391729F062817381CF0109
:100BC0000C9473050895CF92DF92EF92FF920F93EA
:100BD0001F93CF93DF93CDB7DEB729970FB6F89465
:100BE000DEBF0FBECDBF8C01DC0118968D919C91AC
:100BF000892B09F497C00E94050AF801C684D7849E
:100C0000E088F1886C197D098E099F096C3271406A
:100C10008105910580F3F894D80114968D919C91EB
:100C200015979A83898318960D90BC91A02D7D010C
:100C3000EFEFEE1AFE0A8C918987D8018C915296BB
:100C40000D90BC91A02D882309F434C11D82AB32D4
:100C5000B10509F076C09BB1F8018489982B98877B
:100C60009BB1809589238F838F818E83898587FFB0
:100C700002C088858E8358856F8149853E812D818C
:100C800089819A81D7015BB9262F3BB900C046FD07
:100C9000252F6BB900C05BB9362F2BB900C045FDBD
:100CA000352F6BB900C05BB9262F3BB900C044FD9E
:100CB000252F6BB900C05BB9362F2BB900C043FD9F
:100CC000352F6BB900C05BB9262F3BB900C042FD80
:100CD000252F6BB900C05BB9362F2BB900C041FD81
:100CE000352F6BB900C05BB9262F3BB900C040FD62
:100CF000252F6BB901975BB9362F2BB94D9147FD65
:100D0000352F6BB901F649873E832D839A838983FA
:100D100078940E94050AD8011E966D937D938D9359
:100D20009C93519729960FB6F894DEBF0FBECDBFA6
:100D3000DF91CF911F910F91FF90EF90DF90CF90B7
:100D40000895A532B10509F059C095B1F80184891B
:100D5000982B988795B1809589238F838F818E8377
:100D6000898587FF02C088858E8358856F81498574
:100D70003E812D8189819A81D70155B9262F35B9B8
:100D800000C046FD252F65B900C055B9362F25B9DD
:100D900000C045FD352F65B900C055B9262F35B9BE
:100DA00000C044FD252F65B900C055B9362F25B9BF
:100DB00000C043FD352F65B900C055B9262F35B9A0
:100DC00000C042FD252F65B900C055B9362F25B9A1
:100DD00000C041FD352F65B900C055B9262F35B982
:100DE00000C040FD252F65B9019755B9362F25B9AB
:100DF0004D9147FD352F65B901F685CF989709F0DC
:100E000087CF98B1F8018489982B988798B18095FD
:100E100089238F838F818E83898587FF02C0888590
:100E20008E8358856F8149853E812D8189819A8184
:100E3000D70158B9262F38B900C046FD252F68B90B
:100E400000C058B9362F28B900C045FD352F68B904
:100E500000C058B9262F38B900C044FD252F68B905
:100E600000C058B9362F28B900C043FD352F68B9E6
:100E700000C058B9262F38B900C042FD252F68B9E7
:100E800000C058B9362F28B900C041FD352F68B9C8
:100E900000C058B9262F38B900C040FD252F68B9C9
:100EA000019758B9362F28B94D9147FD352F68B9AC
:100EB00001F629CF9C91F8018489982B98879C9101
:100EC000809589238F838F818C8388E08B835885DD
:100ED0006F8149853B812C8189819A81F7015C93DF
:100EE00047FD252F2C93262F3A9531F0441F6C9304
:100EF00000C000C000C0F3CF6C93000038E0419107
:100F0000019769F7F801B38BA28B49873B832C8348
:100F1000FDCE1F93CF93DF93EC01162F8981882399
:100F200031F08E8187FD03C060E00E94220B1E839A
:100F30008981882341F061E0812F0E94220B60E0CB
:100F4000812F0E945E0B812F90E0FC01EC51FF4F3E
:100F5000E491F0E0EE0FFF1FE85FFE4F2591349122
:100F60003B8B2A8BFC01E453FF4FE491EC8BDF9128
:100F7000CF911F910895EF92FF921F93CF93DF932C
:100F8000EC017B01142F19821F82198618861E8698
:100F90001F86188A198A62E570E00E94AD05B701C4
:100FA000CE010E947305612FCE010E948907CE01F8
:100FB000DF91CF911F91FF90EF900C9461050F93FB
:100FC0001F93DC0112968D919C91139768177907F6
:100FD000C0F517968C911797882361F0489FA00160
:100FE0001124452F829F90011124232F809F80017F
:100FF0001124012F1D968C911D971896ED91FC914F
:1010000019971A969C911A9789131EC0CB01880FC5
:10101000991F680F791F6E0F7F1F1A96EC911A9710
:10102000E60FF72FF11D40831B96EC911B97E60FFF
:10103000F72FF11D20831C968C91680F711DFB0109
:1010400000831F910F910895660F771F660F771F1A
:101050006E0F7F1FFB01E80FF11D1082DECF4F9254
:101060005F926F927F928F929F92AF92BF92EF9218
:10107000FF92CF93DF93DC0112968D919C91139791
:101080006817790708F0E9C01D968C911D971A968C
:101090009C911A9718964D915C91199717968C9080
:1010A0001797282F30E01B96EC911B97F0E01C96C9
:1010B000AC91B0E0891364C0CB01880F991F680F11
:1010C000791F460F571F240F351FE9012881E40FB0
:1010D000F51FF080A40FB51FCC91882009F445C0FE
:1010E000912CB12CA12C622F70E0762F6627072E51
:1010F000000C880B990BA50194010E944B13390138
:10110000552444246F2D70E0762F6627072E000C9F
:10111000880B990BA50194010E944B13B42FA32FA8
:10112000922F8827482A592A6A2A7B2A6C2F70E036
:10113000762F6627072E000C880B990BA5019401CA
:101140000E944B13C301B201622B732B842B952B8E
:10115000DF91CF91FF90EF90BF90AF909F908F90D5
:101160007F906F905F904F9008956F2D70E090E0AA
:1011700080E0982F872F762F6627822B6C2BE8CF65
:10118000660F771F660F771F640F751F260F371FB7
:10119000E9013881EB01C90FD11DF880E60FF71F77
:1011A000C081A60FB71FEC90882009F44BC0912C8A
:1011B000B12CA12C632F70E0762F6627072E000C30
:1011C000880B990BA50194010E944B13722E662483
:1011D000552444246F2D70E0762F6627072E000CCF
:1011E000880B990BA50194010E944B13A901332789
:1011F0002227422A532A642A752A6E2D70E0762F00
:101200006627072E000C880B990BA50194010E94FC
:101210004B13422A532A642A752A6C2F70E0762FCA
:101220006627072E000C880B990BA50194010E94DC
:101230004B13942F832F722F6627642975298629D3
:10124000972986CF6F2D70E090E080E0CB01772763
:101250006627932B6E297C2B7BCF60E070E0CB015F
:1012600077CF4F925F926F927F928F929F92AF92C1
:10127000BF92DF92EF92FF920F931F93CF93DF9372
:10128000EC017B01142FD22E0E942F08412E512CED
:10129000712C612C882E912CB12CA12C481459044E
:1012A0006A047B04C9F48D2C912CB12CA12C472EFF
:1012B000512C712C612C84149504A604B70461F49C
:1012C000802E912CB12CA12C772788279927861660
:1012D0009706A806B906C1F02D2D412FB701CE0102
:1012E0000E94DF07CE01DF91CF911F910F91FF90F8
:1012F000EF90DF90BF90AF909F908F907F906F9016
:101300005F904F900C94E305DF91CF911F910F9167
:10131000FF90EF90DF90BF90AF909F908F907F9065
:101320006F905F904F900895FC0160830895CF9374
:10133000DF93EC0126E040E051EE60E070E08FE7E3
:1013400092E00E94DE0C8AE5888389838A838B83FE
:101350008C838D838E838F83DF91CF9108951F922D
:101360000F920FB60F9211242F933F938F939F9359
:10137000AF93BF938091DA019091DB01A091DC01E2
:10138000B091DD013091D90126E0230F2D3758F5BA
:101390000296A11DB11D2093D9018093DA0190938B
:1013A000DB01A093DC01B093DD018091DE0190911F
:1013B000DF01A091E001B091E1010196A11DB11DF5
:1013C0008093DE019093DF01A093E001B093E101EF
:1013D000BF91AF919F918F913F912F910F900FBE31
:1013E0000F901F90189529E8230F0396A11DB11D9A
:1013F000D2CF2FB7F8946091DA017091DB01809120
:10140000DC019091DD012FBF08953FB7F8948091E2
:10141000DE019091DF01A091E001B091E10126B5DC
:10142000A89B05C02F3F19F00196A11DB11D3FBF1C
:10143000BA2FA92F982F8827BC01CD01620F711DEB
:10144000811D911D43E0660F771F881F991F4A95E4
:10145000D1F708958F929F92AF92BF92CF92DF9271
:10146000EF92FF926B017C010E94050A4B015C0127
:10147000C114D104E104F104E9F00E94FB100E94C0
:10148000050A681979098A099B09683E7340810534
:10149000910570F321E0C21AD108E108F10888EE45
:1014A000880E83E0981EA11CB11CC114D104E10474
:1014B000F10429F7FF90EF90DF90CF90BF90AF90AD
:1014C0009F908F9008958330910528F0880F991F81
:1014D00004970197F1F70895789484B5826084BDEC
:1014E00084B5816084BD85B5826085BD85B5816028
:1014F00085BDEEE6F0E0808181608083E1E8F0E088
:101500001082808182608083808181608083E0E8B6
:10151000F0E0808181608083E1EBF0E08081846095
:101520008083E0EBF0E0808181608083E1E9F0E09E
:10153000808182608083808181608083E0E9F0E047
:10154000808181608083E1EAF0E080818260808335
:10155000808181608083E0EAF0E080818160808327
:10156000EAE7F0E08081846080838081826080830C
:1015700080818E7F80838081806880831092C1000B
:1015800008958E3008F08E502091110190E4299F2B
:10159000900111248770822B80937C0080917A00C7
:1015A000806480937A0080917A0086FDFCCF8091E0
:1015B000780090917900089581508D3008F03DC0F9
:1015C000E82FF0E0EA51F54F0C946D13FD0A010B82
:1015D000F30AF90A1D0B1D0B040B0A0B0E0B140B5F
:1015E0001D0B180B1E0B809180008F77809380005D
:1015F0000895809180008F7DF9CF84B58F7784BD69
:10160000089584B58F7DFBCF8091B0008F77809354
:10161000B00008958091B0008F7DF9CF8091900047
:101620008F77809390000895809190008F7DF9CFFF
:101630008091A0008F778093A00008958091A000F2
:101640008F7DF9CFCF93DF9390E0FC01E453FF4F00
:1016500024918C519F4FFC0184918823C9F090E024
:10166000880F991FFC01EC5EFE4FA591B491FC011F
:10167000E85FFE4FC591D49161110DC09FB7F894FA
:101680008C91209582238C938881282328839FBF67
:10169000DF91CF910895623051F49FB7F8943C9157
:1016A000822F809583238C93E8812E2BEFCF8FB7E9
:1016B000F894EC912E2B2C938FBFEACF1F93CF93EE
:1016C000DF93282F30E0F901EC54FF4F8491F901AA
:1016D000E453FF4FD491F901EC51FF4FC491CC2357
:1016E000A9F0162F81110E94DC0AEC2FF0E0EE0F1A
:1016F000FF1FE85FFE4FA591B4918FB7F894EC916E
:10170000111108C0D095DE23DC938FBFDF91CF91FC
:101710001F910895DE2BF8CFCF93DF93282F30E071
:10172000F901EC54FF4F8491F901E453FF4FD49138
:10173000F901EC51FF4FC491CC23A1F081110E941B
:10174000DC0AEC2FF0E0EE0FFF1FE450FF4FA591F5
:10175000B491EC91ED2381E090E009F480E0DF9119
:10176000CF91089580E090E0FACF0F931F9390E01F
:10177000FC01E453FF4F7491FC01EC51FF4FE491E5
:101780006111672FF0E0EE0FFF1FE450FF4F8591CE
:10179000949189019A01B3E0000F111F221F331F9A
:1017A000BA95D1F744E036952795179507954A9550
:1017B000D1F7462F672F0E94BF0061157105810583
:1017C000910591F06F5F7F4F8F4F9F4F24E0660F21
:1017D000771F881F991F2A95D1F733E09695879533
:1017E000779567953A95D1F71F910F910895FC0170
:1017F000918D228D892F90E0805C9F4F821B9109F3
:101800008F7399270895FC01918D828D981731F07F
:10181000828DE80FF11D858D90E008958FEF9FEF89
:101820000895FC01918D828D981761F0A28DAE0F05
:10183000BF2FB11D5D968C91928D9F5F9F73928F8C
:1018400090E008958FEF9FEF0895FC01538D448D34
:10185000252F30E0842F90E0821B930B541710F05B
:10186000CF9608950197089582E99DE0892B49F06C
:1018700080E090E0892B29F00E94920D81110E9456
:10188000000081E29EE0892B49F080E090E0892B06
:1018900029F00E94210E81110C9400000895FC0192
:1018A000A48DA80FB92FB11DA35ABF4F2C91848DC1
:1018B00090E001968F739927848FA689B7892C931E
:1018C000A089B1898C91837080648C93938D848D71
:1018D000981306C00288F389E02D80818F7D808374
:1018E0000895CF93DF93EC01888D8823B9F0AA89FE
:1018F000BB89E889F9898C9185FD03C0808186FDCB
:101900000DC00FB607FCF7CF8C9185FFF2CF808119
:1019100085FFEDCFCE010E944F0CE9CFDF91CF9133
:101920000895EF92FF920F931F93CF93DF93EC01F3
:1019300081E0888F9B8D8C8D98131AC0E889F98976
:10194000808185FF15C09FB7F894EE89FF89608379
:10195000E889F98980818370806480839FBF81E0FA
:1019600090E0DF91CF911F910F91FF90EF9008953C
:10197000F62E0B8D10E00F5F1F4F0F731127E02E17
:101980008C8D8E110CC00FB607FCFACFE889F9894F
:10199000808185FFF5CFCE010E944F0CF1CFEB8DFA
:1019A000EC0FFD2FF11DE35AFF4FF0829FB7F89423
:1019B0000B8FEA89FB8980818062CFCFCF92DF9243
:1019C000EF92FF921F93CF93DF93EC016A017B01AB
:1019D000122F60E874E88EE190E0A70196010E9462
:1019E0004B132150310941095109569547953795B7
:1019F0002795E889F98982E08083211580E13807FD
:101A000098F0E889F989108260E472E48FE090E050
:101A1000A70196010E944B13215031094109510938
:101A20005695479537952795EC85FD853083EE854E
:101A3000FF852083188EEC89FD891083EA89FB8954
:101A4000808180618083EA89FB89808188608083CE
:101A5000EA89FB89808180688083EA89FB898081AB
:101A60008F7D8083DF91CF911F91FF90EF90DF906A
:101A7000CF9008951F920F920FB60F9211242F93BB
:101A80008F939F93EF93FF93E091F201F091F30115
:101A90008081E091F801F091F90182FD1BC09081F5
:101AA0008091FB018F5F8F732091FC01821741F0C1
:101AB000E091FB01F0E0EE51FE4F958F8093FB012A
:101AC000FF91EF919F918F912F910F900FBE0F90EB
:101AD0001F9018958081F4CF1F920F920FB60F922E
:101AE00011242F933F934F935F936F937F938F9323
:101AF0009F93AF93BF93EF93FF9382EE91E00E9489
:101B00004F0CFF91EF91BF91AF919F918F917F917A
:101B10006F915F914F913F912F910F900FBE0F905A
:101B20001F90189582EE91E00E94F70B21E0892B1F
:101B300009F420E0822F0895E2EEF1E01382128290
:101B400088EE93E0A0E0B0E084839583A683B7831A
:101B500087E191E09183808385EC90E0958784878D
:101B600084EC90E09787868780EC90E0918B808B67
:101B700081EC90E0938B828B82EC90E0958B848B50
:101B800086EC90E0978B868B118E128E138E148EBE
:101B900008951F920F920FB60F9211242F938F93D7
:101BA0009F93EF93FF93E0918F02F09190028081D9
:101BB000E0919502F091960282FD1BC09081809188
:101BC00098028F5F8F7320919902821741F0E09104
:101BD0009802F0E0E158FD4F958F80939802FF91B5
:101BE000EF919F918F912F910F900FBE0F901F90AB
:101BF00018958081F4CF1F920F920FB60F92112487
:101C00002F933F934F935F936F937F938F939F9304
:101C1000AF93BF93EF93FF938FE792E00E944F0C37
:101C2000FF91EF91BF91AF919F918F917F916F91B4
:101C30005F914F913F912F910F900FBE0F901F908A
:101C400018958FE792E00E94F70B21E0892B09F4A9
:101C500020E0822F0895EFE7F2E01382128288EEEF
:101C600093E0A0E0B0E084839583A683B78387E107
:101C700091E0918380838DEC90E0958784878CEC54
:101C800090E09787868788EC90E0918B808B89EC39
:101C900090E0938B828B8AEC90E0958B848B8EEC1A
:101CA00090E0978B868B118E128E138E148E089572
:101CB000AF92BF92CF92DF92EF92FF920F931F935A
:101CC000CF93DF936C017B018B01040F151FEB0198
:101CD0005E01AE18BF08C017D10759F06991D6014F
:101CE000ED91FC910190F081E02DC6010995892BC1
:101CF00079F7C501DF91CF911F910F91FF90EF9080
:101D0000DF90CF90BF90AF900895FB01019000202D
:101D1000E9F73197AF01461B570BDC01ED91FC91C0
:101D20000280F381E02D0994DC01ED91FC9101909A
:101D3000F081E02D09948F929F92AF92BF92EF9223
:101D4000FF920F931F93CF93DF93CDB7DEB7A19789
:101D50000FB6F894DEBF0FBECDBF7C01FA01CB01F8
:101D600019A2223008F42AE08E010F5D1F4F822E47
:101D7000912CB12CA12CBF01A50194010E944B1301
:101D8000F901CA016A300CF5605DD8016E938D01CE
:101D9000232B242B252B79F790E080E0109721F05E
:101DA000BD01C7010E94850EA1960FB6F894DEBF53
:101DB0000FBECDBFDF91CF911F910F91FF90EF909C
:101DC000BF90AF909F908F900895695CDECF2115F2
:101DD000310541F4DC01ED91FC910190F081E02DA1
:101DE000642F09940C949B0E9A01AB0170E060E0A3
:101DF0000C94E70E2F923F924F925F926F927F92D8
:101E00008F929F92AF92BF92CF92DF92EF92FF920A
:101E10001F93CF93DF93EC016A017B01722EAB011C
:101E20009601CB01B6010E943A1365E271E081117F
:101E300026C046015701E894B7F82FEF3FEF4FE770
:101E40005FE7C501B4010E943A1381110CC02FEF66
:101E50003FEF4FE75FE7C501B4010E94691169E2F6
:101E600071E0181664F02FEF3FEF4FE75FE4C70112
:101E7000B6010E94C8121816B4F46DE271E0CE01EA
:101E8000DF91CF911F91FF90EF90DF90CF90BF90A7
:101E9000AF909F908F907F906F905F904F903F900A
:101EA0002F900C94850E2FEF3FEF4FE75FECC701AB
:101EB000B6010E94691187FDE0CF20E030E0A90162
:101EC000C701B6010E946911312C212C87FF09C07E
:101ED0006DE2CE010E94940E1C01F7FAF094F7F81F
:101EE000F09410E060E070E080E09FE3711641F054
:101EF00020E030E040E251E40E946E111F5FF6CF17
:101F0000A70196010E94FD102B013C010E94E711E0
:101F10004B015C012AE0BC01A401CE010E949B0E92
:101F20007C01E20CF31C1123B1F1C501B4010E9444
:101F300016129B01AC01C301B2010E94FC104B01BF
:101F40005C016EE2CE010E94940EE80EF91E115063
:101F500010F120E030E040E251E4C501B4010E94FC
:101F6000CD122B013C010E94E7114B014AE050E0E9
:101F7000CE010E94F40EE80EF91EB40190E080E05C
:101F80000E9416129B01AC01C301B2010E94FC1019
:101F90004B015C01DCCFC701DF91CF911F91FF9016
:101FA000EF90DF90CF90BF90AF909F908F907F90F9
:101FB0006F905F904F903F902F9008950C94FA0E81
:101FC0000F931F93CF93DF93EC010E94F909688769
:101FD00079878A879B87E881F9810284F385E02DE0
:101FE000CE01099597FF15C00E94F909088519854A
:101FF0002A853B85601B710B820B930B0C811D8125
:102000002E813F81601771078207930720F38FEFBE
:102010009FEFDF91CF911F910F910895FC014483B1
:1020200055836683778308958F929F92AF92BF9274
:10203000CF92DF92EF92FF920F931F93CF93DF9394
:102040004C017A018A01020F131FEA01C62E660FA6
:10205000DD085E01AE18BF08C017D10751F0C401FA
:102060000E94E00F97FD05C0C816D90611F08993AC
:10207000F0CFC501DF91CF911F910F91FF90EF90AD
:10208000DF90CF90BF90AF909F908F900895823057
:10209000A1F028F4882341F0813049F0089583307D
:1020A000E9F0843009F1089510926E00089580914E
:1020B0006F008D7F80936F000895809170008D7FF9
:1020C0008093700081E08093B0008091B100887FA0
:1020D00084608093B1001092B300089580917100E4
:1020E0008D7F809371000895809172008D7F809321
:1020F00072000895CF93C82F80911201C8130DC0AC
:10210000E0E2F1E084919FEF909312010E9447106A
:1021100060E08C2FCF910C945E0B8FEFF7CF1F9266
:102120000F920FB60F9211242F933F934F935F930B
:102130006F937F938F939F93AF93BF93EF93FF938F
:1021400080911F0390912003A0912103B09122035D
:10215000892B8A2B8B2BD1F190911C03E0911D03CD
:10216000F0911E0380818927808380911F039091C5
:102170002003A0912103B0912203181619061A0614
:102180001B069CF480911F0390912003A0912103D2
:10219000B09122030197A109B10980931F03909385
:1021A0002003A0932103B0932203FF91EF91BF91ED
:1021B000AF919F918F917F916F915F914F913F91DF
:1021C0002F910F900FBE0F901F90189580911201C4
:1021D0000E947A10EACF08950E946C0A0E94EB10C8
:1021E0000E940B01C4E3DCE00E94C9012097E1F3E7
:1021F0000E94340CF9CF08955058BB27AA270E949B
:1022000014110C948E120E94801238F00E948712D2
:1022100020F039F49F3F19F426F40C947D120EF44B
:10222000E095E7FB0C947712E92F0E949F1258F378
:10223000BA17620773078407950720F079F4A6F5AB
:102240000C94C1120EF4E0950B2EBA2FA02D0B01A9
:10225000B90190010C01CA01A0011124FF27591BEB
:1022600099F0593F50F4503E68F11A16F040A22FF1
:10227000232F342F4427585FF3CF46953795279562
:10228000A795F0405395C9F77EF41F16BA0B620B61
:10229000730B840BBAF09150A1F0FF0FBB1F661FA8
:1022A000771F881FC2F70EC0BA0F621F731F841FEB
:1022B00048F4879577956795B795F7959E3F08F011
:1022C000B0CF9395880F08F09927EE0F97958795D3
:1022D00008950E94531208F481E008950E9482112B
:1022E0000C948E120E94871258F00E94801240F0C7
:1022F00029F45F3F29F00C94771251110C94C2120B
:102300000C947D120E949F1268F39923B1F3552318
:1023100091F3951B550BBB27AA27621773078407F8
:1023200038F09F5F5F4F220F331F441FAA1FA9F38E
:1023300035D00E2E3AF0E0E832D091505040E6957C
:10234000001CCAF72BD0FE2F29D0660F771F881FDD
:10235000BB1F261737074807AB07B0E809F0BB0BD0
:10236000802DBF01FF2793585F4F3AF09E3F5105E4
:1023700078F00C9477120C94C2125F3FE4F3983E0D
:10238000D4F3869577956795B795F7959F5FC9F7CD
:10239000880F911D9695879597F90895E1E0660F4E
:1023A000771F881FBB1F621773078407BA0720F0C7
:1023B000621B730B840BBA0BEE1F88F7E095089530
:1023C0000E94E7116894B1110C94C21208950E9402
:1023D000A71288F09F5798F0B92F9927B751B0F0FE
:1023E000E1F0660F771F881F991F1AF0BA95C9F799
:1023F00014C0B13091F00E94C112B1E008950C9464
:10240000C112672F782F8827B85F39F0B93FCCF316
:10241000869577956795B395D9F73EF49095809515
:10242000709561957F4F8F4F9F4F0895E89409C035
:1024300097FB3EF490958095709561957F4F8F4FF7
:102440009F4F9923A9F0F92F96E9BB279395F6950D
:10245000879577956795B795F111F8CFFAF4BB0F8B
:1024600011F460FF1BC06F5F7F4F8F4F9F4F16C0EF
:10247000882311F096E911C0772321F09EE8872F79
:10248000762F05C0662371F096E8862F70E060E035
:102490002AF09A95660F771F881FDAF7880F9695AE
:1024A000879597F90895990F0008550FAA0BE0E852
:1024B000FEEF16161706E807F907C0F01216130606
:1024C000E407F50798F0621B730B840B950B39F446
:1024D0000A2661F0232B242B252B21F408950A26AC
:1024E00009F4A140A6958FEF811D811D089597F9EC
:1024F0009F6780E870E060E008959FEF80EC0895AA
:1025000000240A94161617061806090608950024D2
:102510000A9412161306140605060895092E03944C
:10252000000C11F4882352F0BB0F40F4BF2B11F4C0
:1025300060FF04C06F5F7F4F8F4F9F4F089557FD1F
:102540009058440F551F59F05F3F71F04795880F21
:1025500097FB991F61F09F3F79F0879508951216B8
:1025600013061406551FF2CF4695F1DF08C0161664
:1025700017061806991FF1CF869571056105089415
:102580000895E894BB2766277727CB0197F908952C
:102590000E94531208F48FEF08950E94E0120C94E9
:1025A0008E120E94801238F00E94871220F095232C
:1025B00011F00C9477120C947D1211240C94C21219
:1025C0000E949F1270F3959FC1F3950F50E0551F25
:1025D000629FF001729FBB27F00DB11D639FAA2778
:1025E000F00DB11DAA1F649F6627B00DA11D661FC7
:1025F000829F2227B00DA11D621F739FB00DA11DE8
:10260000621F839FA00D611D221F749F3327A00DA1
:10261000611D231F849F600D211D822F762F6A2F3D
:1026200011249F5750409AF0F1F088234AF0EE0FA2
:10263000FF1FBB1F661F771F881F91505040A9F7CF
:102640009E3F510580F00C9477120C94C2125F3FAC
:10265000E4F3983ED4F3869577956795B795F7950B
:10266000E7959F5FC1F7FE2B880F911D9695879583
:1026700097F908950E945312880B990B0895991B9E
:1026800079E004C0991F961708F0961B881F7A9569
:10269000C9F780950895A1E21A2EAA1BBB1BFD0164
:1026A0000DC0AA1FBB1FEE1FFF1FA217B307E40731
:1026B000F50720F0A21BB30BE40BF50B661F771F89
:1026C000881F991F1A9469F7609570958095909569
:1026D0009B01AC01BD01CF010895EE0FFF1F0590D6
:1026E000F491E02D09940F931F93CF93DF938230E1
:1026F000910510F482E090E0E0912503F09126032B
:1027000030E020E0B0E0A0E0309799F421153105E9
:1027100009F44AC0281B390B24303105D8F58A81C9
:102720009B816115710589F1FB0193838283FE0111
:1027300011C0408151810281138148175907E0F08F
:102740004817590799F4109761F012960C93129755
:1027500013961C933296CF01DF91CF911F910F9169
:1027600008950093250310932603F4CF2115310516
:1027700051F04217530738F0A901DB019A01BD015E
:10278000DF01F801C1CFEF01F9CF909326038093C9
:102790002503CDCFFE01E20FF31F819391932250C9
:1027A000310939832883D7CF209123033091240323
:1027B000232B41F420910201309103013093240333
:1027C000209323032091000130910101211531054F
:1027D00041F42DB73EB74091040150910501241BEF
:1027E000350BE0912303F0912403E217F307A0F4E3
:1027F0002E1B3F0B2817390778F0AC014E5F5F4F57
:102800002417350748F04E0F5F1F50932403409361
:102810002303819391939FCFF0E0E0E09CCFCF938F
:10282000DF930097E9F0FC01329713821282A091A6
:102830002503B0912603ED0130E020E01097A1F4CC
:1028400020813181820F931F209123033091240333
:102850002817390709F061C0F0932403E09323039C
:10286000DF91CF910895EA01CE17DF07E8F54A819D
:102870005B819E0141155105B1F7E901FB83EA83B4
:1028800049915991C40FD51FEC17FD0761F4808160
:1028900091810296840F951FE90199838883828133
:1028A00093819B838A83F0E0E0E012968D919C9166
:1028B00013970097B9F52D913C911197CD01029690
:1028C000820F931F20912303309124032817390787
:1028D00039F6309751F51092260310922503B093E4
:1028E0002403A0932303BCCFD383C28340815181AF
:1028F000840F951FC817D90761F44E5F5F4F888119
:102900009981480F591F518340838A819B8193830A
:1029100082832115310509F0B0CFF0932603E093AF
:1029200025039ECFFD01DC01C0CF13821282D7CFD9
:10293000DC0101C06D9341505040E0F7089510E074
:10294000C4E9D0E004C0FE010E946D132196C53990
:08295000D107C9F7F894FFCF8D
:10295800000027038000504A4D4144450000642D83
:102968006401FF00000000910C580E250C710CF753
:102978000B110C030C6E616E00696E66006F766653
:0229880000004D
:00000001FF
`;
